import { render, staticRenderFns } from "./Get.vue?vue&type=template&id=1e31d6ba"
import script from "./Get.vue?vue&type=script&lang=js"
export * from "./Get.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports